import { Box } from '@factorialco/deprecated-design-system'

import * as styles from './styles'

interface Props {
  focus?: boolean
  children?: React.ReactNode
}

export const CostCenterAssignmentBaseCard = ({ focus, children }: Props) => {
  return (
    <Box
      border={{
        all: {
          style: 'solid',
          width: 's1',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs016',
      }}
      {...(focus && { style: styles.focusStyles })}
    >
      {children}
    </Box>
  )
}
